module.exports = __webpack_public_path__ + "img/style_icon.136b6e03.svg";